@file:OptIn(InternalResourceApi::class)

package studio.oddpods.cauce.feature.auth.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/studio.oddpods.cauce.feature.auth.generated.resources/"

internal val Res.string.landing_consent_middle: StringResource by lazy {
      StringResource("string:landing_consent_middle", "landing_consent_middle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 34),
      ))
    }

internal val Res.string.landing_consent_prefix: StringResource by lazy {
      StringResource("string:landing_consent_prefix", "landing_consent_prefix", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45, 74),
      ))
    }

internal val Res.string.landing_consent_privacy: StringResource by lazy {
      StringResource("string:landing_consent_privacy", "landing_consent_privacy", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 120, 63),
      ))
    }

internal val Res.string.landing_consent_suffix: StringResource by lazy {
      StringResource("string:landing_consent_suffix", "landing_consent_suffix", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 184, 34),
      ))
    }

internal val Res.string.landing_consent_terms: StringResource by lazy {
      StringResource("string:landing_consent_terms", "landing_consent_terms", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 219, 57),
      ))
    }

internal val Res.string.landing_continue: StringResource by lazy {
      StringResource("string:landing_continue", "landing_continue", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 277, 36),
      ))
    }

internal val Res.string.landing_email_label: StringResource by lazy {
      StringResource("string:landing_email_label", "landing_email_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 314, 35),
      ))
    }

internal val Res.string.landing_error_invalid_email: StringResource by lazy {
      StringResource("string:landing_error_invalid_email", "landing_error_invalid_email", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 350, 55),
      ))
    }

internal val Res.string.landing_error_required: StringResource by lazy {
      StringResource("string:landing_error_required", "landing_error_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 406, 54),
      ))
    }

internal val Res.string.landing_error_send_failed: StringResource by lazy {
      StringResource("string:landing_error_send_failed", "landing_error_send_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 461, 69),
      ))
    }

internal val Res.string.landing_headline: StringResource by lazy {
      StringResource("string:landing_headline", "landing_headline", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 531, 76),
      ))
    }

internal val Res.string.landing_proof_1: StringResource by lazy {
      StringResource("string:landing_proof_1", "landing_proof_1", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 608, 159),
      ))
    }

internal val Res.string.landing_proof_2: StringResource by lazy {
      StringResource("string:landing_proof_2", "landing_proof_2", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 768, 203),
      ))
    }

internal val Res.string.landing_proof_3: StringResource by lazy {
      StringResource("string:landing_proof_3", "landing_proof_3", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 972, 99),
      ))
    }

internal val Res.string.landing_subheadline: StringResource by lazy {
      StringResource("string:landing_subheadline", "landing_subheadline", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1072, 151),
      ))
    }

internal val Res.string.otp_change_email: StringResource by lazy {
      StringResource("string:otp_change_email", "otp_change_email", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1224, 44),
      ))
    }

internal val Res.string.otp_code_label: StringResource by lazy {
      StringResource("string:otp_code_label", "otp_code_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1269, 50),
      ))
    }

internal val Res.string.otp_error_invalid: StringResource by lazy {
      StringResource("string:otp_error_invalid", "otp_error_invalid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1320, 49),
      ))
    }

internal val Res.string.otp_error_verify_failed: StringResource by lazy {
      StringResource("string:otp_error_verify_failed", "otp_error_verify_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1370, 71),
      ))
    }

internal val Res.string.otp_resend: StringResource by lazy {
      StringResource("string:otp_resend", "otp_resend", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1442, 38),
      ))
    }

internal val Res.string.otp_subtitle: StringResource by lazy {
      StringResource("string:otp_subtitle", "otp_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1481, 56),
      ))
    }

internal val Res.string.otp_title: StringResource by lazy {
      StringResource("string:otp_title", "otp_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1538, 37),
      ))
    }

internal val Res.string.otp_verify: StringResource by lazy {
      StringResource("string:otp_verify", "otp_verify", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1576, 30),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("landing_consent_middle", Res.string.landing_consent_middle)
  map.put("landing_consent_prefix", Res.string.landing_consent_prefix)
  map.put("landing_consent_privacy", Res.string.landing_consent_privacy)
  map.put("landing_consent_suffix", Res.string.landing_consent_suffix)
  map.put("landing_consent_terms", Res.string.landing_consent_terms)
  map.put("landing_continue", Res.string.landing_continue)
  map.put("landing_email_label", Res.string.landing_email_label)
  map.put("landing_error_invalid_email", Res.string.landing_error_invalid_email)
  map.put("landing_error_required", Res.string.landing_error_required)
  map.put("landing_error_send_failed", Res.string.landing_error_send_failed)
  map.put("landing_headline", Res.string.landing_headline)
  map.put("landing_proof_1", Res.string.landing_proof_1)
  map.put("landing_proof_2", Res.string.landing_proof_2)
  map.put("landing_proof_3", Res.string.landing_proof_3)
  map.put("landing_subheadline", Res.string.landing_subheadline)
  map.put("otp_change_email", Res.string.otp_change_email)
  map.put("otp_code_label", Res.string.otp_code_label)
  map.put("otp_error_invalid", Res.string.otp_error_invalid)
  map.put("otp_error_verify_failed", Res.string.otp_error_verify_failed)
  map.put("otp_resend", Res.string.otp_resend)
  map.put("otp_subtitle", Res.string.otp_subtitle)
  map.put("otp_title", Res.string.otp_title)
  map.put("otp_verify", Res.string.otp_verify)
}
